export const en = {
    'are-you-sure-to-apply-many-campaigns': '{count} campaigns will be changed. Apply the recommendation?',
    'are-you-sure-to-apply-many-groups': '{count} ad groups will be changed. Apply the recommendation?',
    'are-you-sure-to-apply-one-campaigns': '{count} campaign will be changed. Apply the recommendation?',
    'are-you-sure-to-apply-one-groups': '{count} ad group will be changed. Apply the recommendation?',
    'are-you-sure-to-apply-some-campaigns': '{count} campaigns will be changed. Apply the recommendation?',
    'are-you-sure-to-apply-some-groups': '{count} ad groups will be changed. Apply the recommendation?',
    'autotargeting-context-result': 'Autotargeting enabled for "{name}" ad group',
    'autotargeting-context-result-error': 'Cannot enable autotargeting for "{name}" ad group',
    'autotargeting-context-result-error-with-refresh':
        'Cannot enable autotargeting for "{name}" ad group. Please refresh the page',
    'autotargeting-grid-result': 'Autotargeting enabled for "{name}" ad group',
    'autotargeting-grid-result-error': 'Cannot enable autotargeting for "{name}" ad group',
    'autotargeting-grid-result-error-with-refresh':
        'Cannot enable autotargeting for "{name}" ad group. Please refresh the page',
    banner: 'ad No. {id}',
    'banner-title': {
        one: '{count} recommendation for improved ad performance',
        some: '{count} recommendations for improved ad performance',
        many: '{count} recommendations for improved ad performance',
        none: '{count} recommendations for improved ad performance'
    },
    campaign: 'campaign No. {id}',
    'campaign-budget-context-result': 'Budget limit raised for "{name}" campaign',
    'campaign-budget-context-result-error': 'Unable to raise the budget limit for "{name}" campaign',
    'campaign-budget-context-result-error-with-refresh':
        'Unable to raise the budget limit for "{name}" campaign. Please refresh the page',
    'campaign-budget-grid-result': 'Budget limit raised for "{name}" campaign',
    'campaign-budget-grid-result-error': 'Unable to raise the budget limit for "{name}" campaign',
    'campaign-budget-grid-result-error-with-refresh':
        'Unable to raise the budget limit for "{name}" campaign. Please refresh the page',
    'campaign-title': {
        one: '{count} recommendation for improved campaign performance',
        some: '{count} recommendations for improved campaign performance',
        many: '{count} recommendations for improved campaign performance',
        none: '{count} recommendations for improved campaign performance'
    },
    'error-autotargeting': 'Could not enable autotargeting',
    'error-autotargeting-with-refresh': 'Could not enable autotargeting. Please refresh the page',
    'error-campaign-budget': 'Could not raise the budget limit',
    'error-campaign-budget-with-refresh': 'Could not raise the budget limit. Please refresh the page',
    'error-fobidden-pages': 'Could not enable impressions on high-quality sites',
    'error-fobidden-pages-with-refresh': 'Cannot enable impressions on high-quality sites. Please refresh the page',
    'fobidden-pages-context-result': 'Impressions enabled on the high-quality site "{name}"',
    'fobidden-pages-context-result-error': 'Could not enable impressions on the high-quality site "{name}"',
    'fobidden-pages-context-result-error-with-refresh':
        'Cannot enable impressions on the high-quality site "{name}". Please refresh the page',
    'fobidden-pages-grid-result': 'Impressions enabled on high-quality sites for "{name}" campaign',
    'fobidden-pages-grid-result-error': 'Cannot enable impressions on high-quality sites for "{name}" campaign',
    'fobidden-pages-grid-result-error-with-refresh':
        'Cannot enable impressions on high-quality sites for "{name}" campaign. Please refresh the page',
    'general-context-result': 'The recommendation has been applied',
    'general-context-result-error': 'The recommendation has not been applied. An error occurred',
    'general-grid-result': 'The recommendation has been applied',
    'general-grid-result-error': 'An error occurred while applying the recommendation',
    group: 'ad group No. {id}',
    'group-title': {
        one: '{count} recommendation for improved ad group performance',
        some: '{count} recommendations for improved ad group performance',
        many: '{count} recommendations for improved ad group performance',
        none: '{count} recommendations for improved ad group performance'
    },
    'many-items-full-autotargeting-result': 'Autotargeting enabled for {count} ad groups',
    'many-items-full-campaign-budget-result': 'Budget limit raised for {count} campaigns',
    'many-items-full-fobidden-pages-result': 'Impressions on high-quality sites enabled for {count} campaigns',
    'many-items-full-general-result': 'The recommendation has been applied for {count} elements',
    'many-items-partial-autotargeting-result': 'Autotargeting enabled for {count} out of {total} ad groups',
    'many-items-partial-campaign-budget-result': 'Budget limit raised for {count} out of {total} campaigns',
    'many-items-partial-fobidden-pages-result':
        'Impressions enabled on high-quality sites for {count} out of {total} campaigns',
    'many-items-partial-general-result': 'The recommendation has been applied for {count} out of {total} elements',
    'one-item-full-autotargeting-result': 'Autotargeting enabled for {count} ad group',
    'one-item-full-campaign-budget-result': 'Budget limit raised for {count} campaign',
    'one-item-full-fobidden-pages-result': 'Impressions enabled on high-quality sites for {count} campaign',
    'one-item-full-general-result': 'The recommendation has been applied for {count} element',
    'one-item-partial-autotargeting-result': 'Autotargeting enabled for {count} ad group out of {total}',
    'one-item-partial-campaign-budget-result': 'Budget limit raised for {count} campaign out of {total}',
    'one-item-partial-fobidden-pages-result':
        'Impressions enabled on high-quality sites in {count} campaign out of {total}',
    'one-item-partial-general-result': 'The recommendation has been applied for {count} element out of {total}',
    'some-items-full-autotargeting-result': 'Autotargeting enabled for {count} ad groups',
    'some-items-full-campaign-budget-result': 'Budget limit raised for {count} campaigns',
    'some-items-full-fobidden-pages-result': 'Impressions on high-quality sites enabled for {count} campaigns',
    'some-items-full-general-result': 'The recommendation has been applied for {count} elements',
    'some-items-partial-autotargeting-result': 'Autotargeting enabled for {count} out of {total} ad groups',
    'some-items-partial-campaign-budget-result': 'Budget limit raised for {count} out of {total} campaigns',
    'some-items-partial-fobidden-pages-result':
        'Impressions enabled on high-quality sites for {count} out of {total} campaigns',
    'some-items-partial-general-result': 'The recommendation has been applied for {count} out of {total} elements',
    title: {
        one: '{count} recommendation',
        some: '{count} recommendations',
        many: '{count} recommendations',
        none: '{count} recommendations'
    }
};
